import { render, staticRenderFns } from "./item-sell.vue?vue&type=template&id=c70a1374&scoped=true&"
import script from "./item-sell.vue?vue&type=script&lang=js&"
export * from "./item-sell.vue?vue&type=script&lang=js&"
import style0 from "./item-sell.vue?vue&type=style&index=0&id=c70a1374&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70a1374",
  null
  
)

export default component.exports